export default function pxToViewport(pixels: number): number {
  return (pixels / 1080) * 100;
}
